// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dl.ngw-resource-main-section-summary {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 4px;
}
dl.ngw-resource-main-section-summary > dt,
dl.ngw-resource-main-section-summary > dd {
  margin: 0;
  padding: 0;
}
dl.ngw-resource-main-section-summary > dt {
  display: flex;
  gap: 4px;
  min-width: 15ch;
  color: var(--text-secondary);
}
dl.ngw-resource-main-section-summary > dt:after {
  display: inline-block;
  flex-grow: 1;
  background-image: radial-gradient(circle, currentcolor 0.75px, transparent 0.75px);
  background-position: left 0 top 10px;
  background-size: 6px 10px;
  background-repeat: repeat-x;
  min-width: 2em;
  content: "";
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/main-section/MainSection.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,+BAAA;EACA,YAAA;AACJ;AAJA;;EAOQ,SAAA;EACA,UAAA;AACR;AATA;EAYQ,aAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AAAR;AAEQ;EACI,qBAAA;EACA,YAAA;EACA,kFAAA;EAKA,oCAAA;EACA,yBAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;AAJZ","sourcesContent":["dl.ngw-resource-main-section-summary {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 8px 4px;\n\n    > dt,\n    > dd {\n        margin: 0;\n        padding: 0;\n    }\n\n    > dt {\n        display: flex;\n        gap: 4px;\n        min-width: 15ch;\n        color: var(--text-secondary);\n\n        &:after {\n            display: inline-block;\n            flex-grow: 1;\n            background-image: radial-gradient(\n                circle,\n                currentcolor 0.75px,\n                transparent 0.75px\n            );\n            background-position: left 0 top 10px;\n            background-size: 6px 10px;\n            background-repeat: repeat-x;\n            min-width: 2em;\n            content: \"\";\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
